import { FC } from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import { toSentenceCase } from '@npi/buddy-utils';

import { maskString } from 'src/utils/validations';

interface PaymentInformationProps {
    formSummaryData: {
        bicNumber: string;
        ibanNumber: string;
        commissionFrequency: string;
        pi_legalCompanyName: string;
        sortCode: string;
        accountNumber: string;
    };
}
// TODO: (KM) Refactor and clean up this component
export const PaymentInformation: FC<PaymentInformationProps> = ({ formSummaryData }) => {
    const theme = useTheme();

    return (
        <Grid item xs={12} sx={{ padding: '32px 24px' }} container>
            <Grid item xs={12} sx={{ borderBottom: '1px solid #F18F34', marginBottom: '24px' }}>
                <Box display="flex" flexDirection="column" gap="8px">
                    <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>Bank Details</Typography>
                </Box>
            </Grid>

            <Grid item xs={12} spacing={3} container>
                <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                        }}
                        color={theme.palette.dark.main}
                    >
                        BIC
                    </Typography>

                    <Typography sx={{ fontSize: '20px', fontWeight: 400 }} color="#8E8E8D">
                        {maskString(formSummaryData?.bicNumber || '') || '-'}
                    </Typography>
                </Grid>

                <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                        }}
                        color={theme.palette.dark.main}
                    >
                        IBAN
                    </Typography>

                    <Typography sx={{ fontSize: '20px', fontWeight: 400 }} color="#8E8E8D">
                        {maskString(formSummaryData?.ibanNumber || '') || '-'}
                    </Typography>
                </Grid>

                <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                        }}
                        color={theme.palette.dark.main}
                    >
                        Account Name
                    </Typography>

                    <Typography sx={{ fontSize: '20px', fontWeight: 400 }} color="#8E8E8D">
                        {formSummaryData?.pi_legalCompanyName || '-'}
                    </Typography>
                </Grid>

                {formSummaryData?.sortCode && formSummaryData?.accountNumber && (
                    <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 600,
                            }}
                            color={theme.palette.dark.main}
                        >
                            Sort Code / Account Number
                        </Typography>

                        <Typography sx={{ fontSize: '20px', fontWeight: 400 }} color="#8E8E8D">
                            {`${maskString(formSummaryData?.sortCode)} / ${maskString(
                                formSummaryData?.accountNumber
                            )}`}
                        </Typography>
                    </Grid>
                )}
            </Grid>

            <Grid
                item
                xs={12}
                sx={{
                    borderBottom: '1px solid #F18F34',
                    marginBottom: '24px',
                    marginTop: '56px',
                }}
            >
                <Box display="flex" flexDirection="column" gap="8px">
                    <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>Bank Details</Typography>
                </Box>
            </Grid>

            <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                    }}
                    color={theme.palette.dark.main}
                >
                    What frequency should the Partner commission statements be generated?
                </Typography>

                <Typography sx={{ fontSize: '20px', fontWeight: 400 }} color="#8E8E8D">
                    {toSentenceCase(formSummaryData?.commissionFrequency || '-')}
                </Typography>
            </Grid>
        </Grid>
    );
};
